export default __webpack_public_path__ + "static/media/car6.1d533e0d.jpg";